/**
 * BPMTimingManager - Musical Time Calculations and BPM Management
 */
import { MUSICAL_CONSTANTS } from '../audio/AudioConstants.js';

export class BPMTimingManager {
  constructor(bpm = MUSICAL_CONSTANTS.bpm.default) {
    this.bpm = Math.max(MUSICAL_CONSTANTS.bpm.min, Math.min(MUSICAL_CONSTANTS.bpm.max, bpm));
    this.divisionMap = MUSICAL_CONSTANTS.divisions;
    this.barLengthMap = {
      1: MUSICAL_CONSTANTS.timeSignature.beatsPerBar,
      2: MUSICAL_CONSTANTS.timeSignature.beatsPerBar * 2,
      4: MUSICAL_CONSTANTS.timeSignature.beatsPerBar * 4,
      8: MUSICAL_CONSTANTS.timeSignature.beatsPerBar * 8
    };
  }

  setBPM(bpm) {
    this.bpm = Math.max(MUSICAL_CONSTANTS.bpm.min, Math.min(MUSICAL_CONSTANTS.bpm.max, bpm));
  }

  getBPM() {
    return this.bpm;
  }

  getTimeForDivision(division, barLength = 1) {
    const secondsPerBeat = 60 / this.bpm;
    const divisionBeats = this.divisionMap[division] || 1;
    return divisionBeats * barLength * secondsPerBeat;
  }

  getTimeForBarLength(barLength) {
    const secondsPerBeat = 60 / this.bpm;
    return barLength * MUSICAL_CONSTANTS.timeSignature.beatsPerBar * secondsPerBeat;
  }

  getMusicalPosition(animationTime) {
    const secondsPerBeat = 60 / this.bpm;
    const totalBeats = animationTime / secondsPerBeat;
    const beatsPerBar = MUSICAL_CONSTANTS.timeSignature.beatsPerBar;
    return {
      bar: Math.floor(totalBeats / beatsPerBar) + 1,
      beat: (Math.floor(totalBeats) % beatsPerBar) + 1,
      division: Math.floor((totalBeats % 1) * 8)
    };
  }

  getAvailableDivisions() {
    return ['64th', '32nd', '16th', '8th', 'quarter', 'half', 'whole', '1bar', '2bars', '4bars', '8bars'];
  }

  getDivisionBeats(division) {
    return this.divisionMap[division] || 1;
  }

  isAlignedWithDivision(time, division, tolerance = MUSICAL_CONSTANTS.sync.tolerance) {
    const divisionTime = this.getTimeForDivision(division);
    const position = time % divisionTime;
    return position < tolerance || position > (divisionTime - tolerance);
  }

  getNextSyncPoint(currentTime, division) {
    const divisionTime = this.getTimeForDivision(division);
    const currentPosition = currentTime % divisionTime;
    return currentTime + (divisionTime - currentPosition);
  }
}
